import React, {useState} from 'react';
import {StyleSheet, View, Platform, Pressable} from 'react-native';

import {observer} from 'mobx-react';

import {RNEText, RNEButton} from '../../components';
import {Icon, Overlay} from 'react-native-elements'; // rne-netzon replaced

import {colorPalette, colors} from '../../../core/config/color.config';

import {
  useAcceptConsultationDetail,
  useCancelConsultationDetail,
} from '../../server/react-query/useConsultation';

import ConsultationDeclineModal from '../modal/ConsultationDeclineModal';
import {useNavigation} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';
import {useToast} from 'react-native-fast-toast';
import {
  ConsultationCancelConfirmationModal,
  ConsultationRequestAcceptanceModal,
} from '..';
import {
  ConsultationRequestResBody,
  ConsultationStatusEnum,
} from '../../server/types/consultation.types';
import {Text} from 'react-native';
import {width, height, totalSize} from 'react-native-dimension';

interface ConsultationAcceptDeclineProps {
  serviceRequest: ConsultationRequestResBody;
}

const ConsultationAcceptDecline = (props: ConsultationAcceptDeclineProps) => {
  const navigation = useNavigation();
  const toast = useToast();

  const [showDenyConsultationModal, setShowDenyConsultationModal] =
    useState(false);

  const [isArchiveConfirmModalVisible, setIsArchiveConfirmModalVisible] =
    useState(false);

  const [isArchiveRequestInProgress, setIsArchiveInProgress] = useState(false);

  const [showAcceptConsultationDialog, setShowAcceptConsultationDialog] =
    useState(false);

  const acceptMutation = useAcceptConsultationDetail({
    basedOn: props.serviceRequest.serviceRequestId,
  });

  const archieveMutation = useCancelConsultationDetail({
    serviceRequestId: props.serviceRequest.serviceRequestId,
    status: ConsultationStatusEnum.ARCHIVED,
  });

  const onDenyConsultation = async () => {
    // setShowDenyConsultationModal(true);
    navigation.navigate(NavigationKey.CONSULTATION_DECLINE, {
            params: {
              id: props.serviceRequest.serviceRequestId,
            },
    });
  };

  const onDenyConsultationComplete = async () => {
    setShowDenyConsultationModal(false);
  };

  const onAcceptConsultation = async () => {
    if (Platform.OS === 'web') {
      setShowAcceptConsultationDialog(true);
    } else {
      navigation.navigate(NavigationKey.CONSULTATION_REQUEST_ACCEPTANCE, {
        onConfirm: navigation.goBack,
        serviceRequest: props.serviceRequest,
      });
    }
  };

  const handleArchiveRequest = async () => {
    try {
      setIsArchiveInProgress(true);
      await archieveMutation.mutateAsync();
      setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible);
      setTimeout(() => {
        setIsArchiveInProgress(false);
      }, 1000);
    } catch (error) {
      setIsArchiveInProgress(false);
    }
  };

  const onAcceptConsultationComplete = async () => {
    setShowAcceptConsultationDialog(false);
  };

  return (
    <>
      <Overlay
        isVisible={showAcceptConsultationDialog}
        onBackdropPress={() => setShowAcceptConsultationDialog(false)}
        overlayStyle={
          Platform.OS === 'web'
            ? webStyles.overlayContainerWeb
            : mobileStyles.overlayContainerMobile
        }>
        <ConsultationRequestAcceptanceModal
          onConfirm={onAcceptConsultationComplete}
          serviceRequest={props.serviceRequest}
        />
      </Overlay>
      {Platform.OS === 'web' ? (
        <View style={webStyles.mainContainer}>
          <View style={webStyles.messageContainer}>
            <RNEText
              label="The patient's name is hidden from view until you accept this consultation. Once you accept this request, the patient will proceed with payment before the consultation starts."
              color="grey"
              variant="button"
              numberOfLines={3}
              ellipsizeMode="tail"
            />
          </View>

          <View style={webStyles.actionContainer}>
            <RNEButton
              title="Decline"
              color="secondary"
              type="outline"
              variant="outlined"
              style={webStyles.buttonStyle}
              onPress={onDenyConsultation}
            />

            <View style={webStyles.buttonSibling}>
              <RNEButton
                title="Accept"
                color="secondary"
                style={webStyles.buttonStyle}
                onPress={onAcceptConsultation}
                loading={acceptMutation.isLoading}
              />
            </View>
          </View>
        </View>
      ) : (
        <View style={mobileStyles.mainContainer}>
          <View style={{marginBottom: height(1.6)}}>
            <RNEText
              label="Do you wish to approve this
consultation request?"
              color={colorPalette.black}
              ellipsizeMode="tail"
              align="center"
              style={{
                fontWeight: '500',
                fontSize: totalSize(1.6),
                fontFamily: 'Quicksand-Bold',
              }}
            />
          </View>
          <View style={mobileStyles.actionContainer}>
            <Pressable
              onPress={onDenyConsultation}
              disabled={acceptMutation.isLoading}>
              <View
                style={[
                  footerBtnStyles.container,
                  footerBtnStyles.declineContainer,
                ]}>
                <View style={footerBtnStyles.btnContainer}>
                  <Text style={footerBtnStyles.declineTxtStyle}>Decline</Text>
                </View>
              </View>
            </Pressable>

            <Pressable
              onPress={onAcceptConsultation}
              disabled={acceptMutation.isLoading}>
              <View
                style={[
                  footerBtnStyles.container,
                  footerBtnStyles.acceptContainer,
                ]}>
                <View style={footerBtnStyles.btnContainer}>
                  <Text style={footerBtnStyles.btnTxtStyle}>Accept</Text>
                </View>
              </View>
            </Pressable>

            <Pressable
              onPress={() =>
                setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible)
              }
              disabled={acceptMutation.isLoading}>
              <View
                style={[
                  footerBtnStyles.container,
                  footerBtnStyles.archiveContainer,
                ]}>
                <View style={footerBtnStyles.btnContainer}>
                  <Text style={footerBtnStyles.btnTxtStyle}>Archive</Text>
                </View>
              </View>
            </Pressable>

            {/* <RNEButton
              title="Decline"
              color="secondary"
              variant="default"
              style={{...mobileStyles.buttonStyle, ...mobileStyles.declineButton}}
              onPress={onDenyConsultation}
            />

            <View style={mobileStyles.buttonSibling}>
              <RNEButton
                title="Accept"
                variant="default"
                color="secondary"
                style={{...mobileStyles.buttonStyle,...mobileStyles.acceptButton}}
                onPress={onAcceptConsultation}
                loading={acceptMutation.isLoading}
              />
            </View> */}

            {/* <View style={mobileStyles.buttonSibling}> */}
            {/* <RNEButton
                title="Archive"
                variant="default"
                color="secondary"
                style={{...mobileStyles.buttonStyle,...styles.archive}}
                onPress={onAcceptConsultation}
                loading={acceptMutation.isLoading}
              /> */}
            {/* <Pressable
                onPress={() =>
                  setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible)
                }
                style={[styles.actionButton, styles.archive]}>
         
                <Text style={[styles.actionText]}>
                  Archive
                </Text>
              </Pressable> */}
            {/* </View> */}
          </View>
          <View style={mobileStyles.messageContainer}>
            <RNEText
              // label="The patient's name is hidden from view until you accept this consultation. Once you accept this request, the patient will proceed with payment before the consultation starts."
              label="The patient's name is hidden from view
until you accept this consultation."
              color="grey"
              ellipsizeMode="tail"
              align="center"
            />
          </View>
        </View>
      )}

      <Overlay
        isVisible={showDenyConsultationModal}
        overlayStyle={
          Platform.OS === 'web'
            ? webStyles.overlayContainerWeb
            : mobileStyles.overlayContainerMobile
        }>
        <ConsultationDeclineModal
          serviceRequestId={props.serviceRequest.serviceRequestId}
          onCancel={() => setShowDenyConsultationModal(false)}
          onConfirm={onDenyConsultationComplete}
        />
      </Overlay>

      <Overlay
        isVisible={isArchiveConfirmModalVisible}
        overlayStyle={sharedStyles.overlayContainer}>
        <ConsultationCancelConfirmationModal
          isLoading={isArchiveRequestInProgress}
          title={'Are you sure you want to archive this consultation?'}
          primaryBtnText={'Yes'}
          secondaryBtnText={'No'}
          onConfirm={handleArchiveRequest}
          onCancel={() =>
            setIsArchiveConfirmModalVisible(!isArchiveConfirmModalVisible)
          }
        />
      </Overlay>
    </>
  );
};

export default observer(ConsultationAcceptDecline);

const webStyles = StyleSheet.create({
  mainContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: colorPalette.light,
  },
  messageContainer: {
    flex: 1,
    justifyContent: 'center',
    marginRight: 16,
  },
  actionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonStyle: {
    // width: width(25),
    paddingHorizontal: width(8),
  },
  buttonSibling: {
    marginLeft: 16,
  },
  overlayContainerWeb: {
    borderRadius: 16,
    paddingVertical: 24,
    maxHeight: '95vh',
  },
});

const mobileStyles = StyleSheet.create({
  mainContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    paddingVertical: height(2),
  },
  messageContainer: {
    alignItems: 'center',
  },
  actionContainer: {
    width: width(100),
    marginBottom: height(1),
    paddingBottom: height(1.5),
    borderBottomWidth: width(0.2),
    borderBottomColor: colorPalette.light,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  buttonStyle: {
    paddingHorizontal: width(7.1),
    height: height(4.5),
  },
  acceptButton: {
    backgroundColor: colors.brightYellow.regular,
    paddingHorizontal: width(7.5),
  },
  declineButton: {
    backgroundColor: 'white',
    borderWidth: totalSize(0.2),
    borderColor: 'red',
    paddingHorizontal: width(6.8),
  },
  buttonSibling: {
    marginLeft: 16,
  },
  overlayContainerMobile: {
    borderRadius: 20,
    paddingHorizontal: 32,
    paddingVertical: 24,
  },
});

// const styles = StyleSheet.create({
//   actionButton: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     paddingVertical: height(1.08),
//     paddingHorizontal: width(4),
//     borderRadius: totalSize(6),
//     // width: width(25),
//   },
//   archive: {
//     backgroundColor: '#3FB4E6',
//     // paddingHorizontal: width(7),
//   },
//   actionText: {
//     fontSize: totalSize(1.3),
//     color: colorPalette.white,
//     textAlign: 'center',
//     fontFamily: 'Quicksand-Bold',
//   },
// });

const sharedStyles = StyleSheet.create({
  overlayContainer: {
    borderRadius: 20,
    marginHorizontal: 40,
  },
});

const footerBtnStyles = StyleSheet.create({
  container: {
    borderWidth: totalSize(0.2),
    padding: totalSize(1.5),
    paddingTop: totalSize(1),
    paddingBottom: totalSize(1),
    paddingRight: width(6.5),
    paddingLeft: width(6.5),
    borderRadius: totalSize(5),
    alignSelf: 'center',
  },
  declineContainer: {
    marginRight: width(5),
    borderColor: colors.brightYellow.regular,
  },
  acceptContainer: {
    marginRight: width(5),
    borderColor: colors.brightYellow.regular,
    backgroundColor: colors.brightYellow.regular,
  },
  archiveContainer: {
    borderColor: '#3FB4E6',
    backgroundColor: '#3FB4E6',
  },
  btnContainer: {
    minWidth: width(12),
    maxWidth: width(12),
  },
  btnTxtStyle: {
    textAlign: 'center',
    color: colorPalette.white,
    fontFamily: 'Quicksand-Bold',
    fontSize: totalSize(1.3),
  },
  declineTxtStyle: {
    textAlign: 'center',
    color: colors.brightYellow.regular,
    fontFamily: 'Quicksand-Bold',
    fontSize: totalSize(1.3),
  },
});
